import { useLazyQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '@components/loader/Loader';
import { extractExternalCode, extractProposalType } from './content';
import { getProposalDetailsMainInfo } from './queries';
import ProposalDetailsPage from '../../proposal-details-page/ProposalDetailsPage';
import ProposalExpatDetailsPage from '../expat/ProposalExpatPage';
import ProposalGenericPage from '../generic/ProposalGenericPage';
import ProposalMedicalPage from '../medical/ProposalMedicalPage';
import ProposalTravelDetailsPage from '../travel/ProposalTravelDetailsPage';
import ProposalFleetDetailsPage from '../fleet/ProposalFleetPage';
import ProposalMarineGroupPage from '../marine-group/ProposalMarineGroupPage';
import {
  GenericLines,
  getGenericLine,
  getLineCategory,
  LineCategory,
} from '@utils/helper-utils';

const LineCategoryComponents: Record<LineCategory, React.FC> = {
  Motor: ProposalDetailsPage,
  Medical: ProposalMedicalPage,
  Travel: ProposalTravelDetailsPage,
  Expat: ProposalExpatDetailsPage,
  Generic: ProposalGenericPage,
};

const MainProposalPage = () => {
  const params = useParams();
  const entityId = params.id;
  const [loading, setLoading] = useState<boolean>(true);
  const [currentLine, setCurrentLine] = useState<{
    number: string;
    category: LineCategory;
    genericLine: GenericLines;
  }>();
  const [type, setType] = useState<string>('');
  const [getProposalDetailsLazy] = useLazyQuery(getProposalDetailsMainInfo());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    setLoading(true);
    const { data } = await getProposalDetailsLazy({
      variables: { id: entityId },
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    });

    const line = extractExternalCode(data);
    const newType = extractProposalType(data);
    const lineCategory = getLineCategory(line);
    const genericLine = getGenericLine(line);
    setCurrentLine({
      number: line,
      category: lineCategory,
      genericLine: genericLine,
    });
    setType(newType);
    setLoading(false);
  };

  const LineComponents: React.FC =
    LineCategoryComponents[currentLine?.category];

  const renderContent = () => {
    if (type?.toUpperCase() === 'GROUP') {
      if (currentLine.genericLine === GenericLines.MARINE) {
        return <ProposalMarineGroupPage />;
      } else if (currentLine.genericLine === GenericLines.MEDICAL_GROUP) {
        return <ProposalMedicalPage />;
      } else {
        return <ProposalFleetDetailsPage />;
      }
    }

    return <LineComponents />;
  };

  if (loading || !currentLine) {
    return <Loader />;
  }

  return renderContent();
};

export default MainProposalPage;
